// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // onestack
  // apiBase: '/onestack-erp-backend',
  // billingApiBase: '/erp-billing',

  //PROD
  apiBase: 'https://erp.tejfire.com/erp-backend',
  billingApiBase: 'https://erp.tejfire.com/erp-billing',

  

  //LOCAL
  //  apiBase: 'http://localhost:8080',
  //  billingApiBase: 'http://localhost:8082',


  //Test
  //  apiBase:'http://202.71.157.170:8090/erp-backend',
  // billingApiBase: 'http://202.71.157.170:8090/erp-billing',

 
    chatbotBase: 'http://202.71.157.170:8008',
  env: "dev", 
};
















/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
